import { RootState } from '@/store';

export const servicesSelector = (state: RootState) => {
  return state.serviceStore.services;
};
